module.exports = __webpack_public_path__ + "static/15-efb3d296062ec2ceac3d6474ca3fa4b2.jpg";